/* eslint-disable @typescript-eslint/default-param-last */
import { Action } from "redux";
import { Socket } from "socket.io-client";

import {
  END_INTERVIEW_FOR_ALL,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  SET_SOCKET,
} from "../constants/ActionTypes";
import initialState from "../store/initialState";

interface ISocketType extends Action {
  payload: {
    socket: Socket;
  };
}

const socketReducer = (state = initialState.socket, action: ISocketType) => {
  switch (action.type) {
    case SET_SOCKET:
      return { ...state, socket: action.payload.socket };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.socket;
    default:
      return state;
  }
};

export default socketReducer;
